import "antd/lib/form/style";
import _Form from "antd/lib/form";
import { connect } from 'dva';
import CI0001C from '../../components/CI/CI0001/index';
function mapDispatchToProps(_ref) {
  var ci0001Info = _ref.ci0001Info;
  return {
    ci0001Info: ci0001Info
  };
}
var CI0001R = _Form.create()(CI0001C);
export default connect(mapDispatchToProps)(CI0001R);